Model = require('./Model').default

module.exports = class SearchResults extends Model
    



// WEBPACK FOOTER //
// ./app/models/SearchResults.coffee